module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "close-window",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close-round"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "clearfix"
  }, [_c('span', [_vm._v("会员登录")]), _vm._v(" "), _c('p', [_vm._v("还没有账号  "), _c('a', {
    on: {
      "click": _vm.reg
    }
  }, [_vm._v("立即注册")])])])]), _vm._v(" "), _c('Form', {
    ref: "login-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin($event)
      }
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin($event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "success",
      "long": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doLogin($event)
      }
    }
  }, [_vm._v(" 登 录 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.forgot
    }
  }, [_vm._v("忘记密码？")])], 1), _vm._v(" "), _c('Form', [_c('header', {
    staticClass: "be divider"
  }, [_vm._v("\n                        第三方帐号登录\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "oauth clearfix"
  }, [_c('a', {
    staticClass: "qq",
    on: {
      "click": _vm.qq_login
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("QQ账号登录")])]), _vm._v(" "), _c('a', {
    staticClass: "wechat",
    on: {
      "click": _vm.weixin_login
    }
  }, [_c('i'), _vm._v(" "), _c('span', [_vm._v("微信账号登录")])])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7962f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/login.vue
// module id = 492
// module chunks = 15